import {useEffect, useRef, useState} from "react";

export default function App() {
    const dialogRef = useRef()
    const textFieldRef = useRef()
    const radioGroupRef = useRef()
    const [tasks, setTasks] = useState({
        cw: [],
        hw: []
    })

    useEffect(() => {
        const storage = localStorage.getItem("tasks")
        if (storage) {
            setTasks(JSON.parse(storage))
        } else {
            store()
        }
    }, []);

    useEffect(() => {
        store()
        radioGroupRef.current.value = "cw"
        textFieldRef.current.value = ""
    }, [tasks])

    function store() {
        localStorage.setItem("tasks", JSON.stringify(tasks))
    }

    function submit() {
        setTasks(prev => {
            if (radioGroupRef.current.value === "cw") {
                return {
                    cw: [...prev.cw, textFieldRef.current.value],
                    hw: prev.hw
                }
            } else {
                return {
                    cw: prev.cw,
                    hw: [...prev.hw, textFieldRef.current.value]
                }
            }
        })
        dialogRef.current.open = false
    }

    return <div style={{height: "100%"}}>
        <mdui-dialog ref={dialogRef} close-on-overlay-click={true} className={"dialog"}>
            <span style={{textAlign: "center"}}>布置作业</span>
            <mdui-radio-group defaultValue={"cw"} ref={radioGroupRef}>
                <mdui-radio value={"cw"}>中作</mdui-radio>
                <mdui-radio value={"hw"}>家作</mdui-radio>
            </mdui-radio-group>
            <mdui-text-field label={"作业"} ref={textFieldRef}></mdui-text-field>
            <mdui-button onClick={submit}>布置</mdui-button>
        </mdui-dialog>
        <mdui-fab extended={true} style={{
            position: "fixed",
            bottom: "4rem",
            right: "1rem",
            zIndex: 999
        }} onClick={() => {
            dialogRef.current.open = true
        }}>布置
        </mdui-fab>
        <mdui-tabs value={"cw"} placement={"bottom-top"} style={{height: "100%"}}>
            <mdui-tab value={"cw"}>中作</mdui-tab>
            <mdui-tab value={"hw"}>家作</mdui-tab>
            <mdui-tab-panel slot={"panel"} value={"cw"}>
                <h1>数学中作</h1>
                <mdui-list>
                    {tasks.cw.map((task, key) => <mdui-list-item key={key} nonclickable={true}>
                        <span>{task}</span>
                        <mdui-button slot={"end-icon"} variant={"text"} onClick={(e) => {
                            setTimeout(() => {
                                setTasks(prev => {
                                    return {
                                        cw: prev.cw.filter((_, index) => index !== key),
                                        hw: prev.hw
                                    }
                                })
                            }, 200)
                            e.target.parentElement.style.display = "none"
                        }}>删除
                        </mdui-button>
                    </mdui-list-item>)}
                </mdui-list>
            </mdui-tab-panel>
            <mdui-tab-panel slot={"panel"} value={"hw"}>
                <h1>数学家作</h1>
                <mdui-list>
                    {tasks.hw.map((task, key) => <mdui-list-item key={key} nonclickable={true}>
                        <span>{task}</span>
                        <mdui-button slot={"end-icon"} variant={"text"} onClick={(e) => {
                            setTimeout(() => {
                                setTasks(prev => {
                                    return {
                                        cw: prev.cw,
                                        hw: prev.hw.filter((_, index) => index !== key)
                                    }
                                })
                            }, 200)
                            e.target.parentElement.style.display = "none"
                        }}>删除
                        </mdui-button>
                    </mdui-list-item>)}
                </mdui-list>
            </mdui-tab-panel>
        </mdui-tabs>
    </div>
}